import React, { type ReactNode, type ChangeEvent } from "react"
import clsx from "classnames"

export const ChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 8L10 13L15 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
interface DropdownProps {
  name: string
  value: string
  disabled?: boolean
  helperText?: string
  error?: string
  children: ReactNode
  id?: string
  className?: string
  label?: string

  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
}

export const Dropdown = ({
  value,
  disabled = false,
  name,
  children,
  helperText,
  error,
  onChange,
  id,
  className = "focus:ring-1 focus:ring-blue-600 focus:outline-hidden",
  label,
}: DropdownProps) => (
  <div className="mt-1 flex flex-col">
    <div className="relative w-full">
      <select
        value={value}
        disabled={disabled}
        className={clsx(
          "min-h-11 w-full appearance-none rounded-md border border-solid border-gray-500 bg-white px-3 py-2 pr-8 text-base text-black",
          { "cursor-not-allowed opacity-50": disabled },
          { "border-red-500": !!error },
          className,
        )}
        onChange={onChange}
        id={id}
        name={name}
        aria-label={label}
      >
        {children}
      </select>
      <ChevronDownIcon
        aria-hidden="true"
        className={clsx(
          "pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-black",
          { "opacity-50": disabled },
        )}
      />
    </div>
    {(error || helperText) && (
      <span className={clsx("mt-1 text-xs", error ? "text-red-600" : "text-gray-500")}>
        {error || helperText}
      </span>
    )}
  </div>
)
